import React from "react";
import { Button } from "react-bootstrap";
import { FiMoon, FiSun } from "react-icons/fi";
import { screenButtons } from "./ctiData";
import { getScreenButtonClass } from "./ctiHelpers";

function NavBar({
  screen,
  onScreenChange,
  statusMeta,
  theme,
  onToggleTheme,
  userData,
}) {
  const profiles = userData?.agentData?.agentTelephony?.profile || [];
  const extension = profiles.find((p) => p.type === "WEBRTC")?.number?.number || profiles.find((p) => p.type === "Soft Phone")?.number?.number;
  return (
    <div className="nav-bar">
      {/* <span className="nav-logo">NEXUS CTI</span> */}
      {screenButtons.map((btn) => (
        <Button
          key={btn.key}
          className={["screen-btn", getScreenButtonClass(btn.key, screen)]
            .join(" ")
            .trim()}
          onClick={() => onScreenChange(btn.key)}
        >
          {btn.label}
        </Button>
      ))}
      <div className="spacer" />
      <div className="agent-badge">
        {/* <div className={`agent-dot ${statusMeta.dotClass}`} /> */}
        <button
          type="button"
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        >
          {theme === "light" ? <FiMoon /> : <FiSun />}
        </button>
        <span className="agent-name">
          {userData?.agentData?.agent_name || "UNKNOWN"}
        </span>
        {extension && (
          <>
            <span className="divider">|</span>
            <span className="agent-ext">Ext. {extension}</span>
          </>
        )}
      </div>
    </div>
  );
}

export default React.memo(NavBar);
